export const voielloConfig = {
  coupon: '',
  coupon_value: 0,
  MEALS_DEFAULT: 0,
  PEOPLE_DEFAULT: 2,
  DISCOUNT: 10,
  FREE_DELIVERY_FROM: 34,
  PEOPLE_OFFER: [2, 4],
  MAX_ITEM: 999,
  EXTRA_QUERY: {
    show: 50,
    page: 1,
    sort_direction: 'asc',
    query: `shopTags.name in ('Casa Voiello') and id in (5176)`,
    'productables': true
  },
  recurring: false,
  addToCartText: 'Aggiungi al carrello la box per procedere con il tuo ordine!',
  header_background: {
    backgroundImage: "url('https://api.quomi.it/oldimg/inaugurazione-2022webp_risultato.webp')",
    backgroundPosition: "center 50%",
    boxShadow: 'inset 0 0 0 2000px rgba(0, 0, 0, 0.5)'
  },
  top_banner_color: {
    backgroundColor: '#012169'
  },
  cta_background: {
    backgroundColor: '#987746'
  },
  payoff: {
    title: 'I sapori di Procida, <br>tutti in una box, <br>a casa tua!',
    subtitle: 'Ricevi a casa la box con tutti gli ingredienti <br> nelle giuste dosi per cucinare 2 ricette deliziose',
    subtitle_2: 'Per te la consegna è gratuita!',
    subtitle_3: `Approfittane ora, è una box in edizione limitata!`
  },
  how_works: {
    subtitle: 'Scopri come ordinare in pochi semplici click la tua box e divertirti in cucina a casa tua!',
    card_1: {
      img: 'https://api.quomi.it/oldimg/Comefunziona1.png',
      title: '1. Scegli la tua box',
      subtitle: 'Aggiungi al carrello la tua box e procedi con l’acquisto'
    },
    card_2: {
      img: 'https://api.quomi.it/oldimg/Comefunziona3.png',
      title: '2. Consegna a domicilio',
      subtitle: 'Ricevi la tua box comodamente a casa tua'
    },
    card_3: {
      img: 'https://api.quomi.it/oldimg/Quomi-kit-ricette-a-casa.webp',
      title: '3. Divertiti in cucina',
      subtitle: 'Segui le istruzioni e prepara piatti deliziosi'
    }
  },
  steps: {
    title:'Ordina ora la tua box in edizione limitata!',
    subtitle: 'Per te la consegna è gratuita!',
    step_title_1: 'Conferma la box',
    step_title_2: 'Crea il tuo account',
    step_title_3: 'Dove vuoi ricevere la tua box?',
    step_title_5: 'Modalità di pagamento',
  }
}